import {Directus} from '@directus/sdk'
import Color from 'color'

function createStatiAperturaChiusuraElement(data, variant) {
  const element = document.createElement('div')
  const elementIcon = document.createElement('span')
  const elementName = document.createElement('span')
  const elementDescription = document.createElement('span')
  const elementBody = document.createElement('div')
  element.append(elementBody)
  elementBody.classList.add('stati-apertura-chiusura__body')
  elementBody.append(elementIcon)
  elementBody.append(elementName)
  element.setAttribute(
    'data-stati-apertura-chiusura-macrostato',
    data.stati_apertura_chiusura_id.macrostato
  )
  element.classList.add('stati-apertura-chiusura')
  element.classList.add(`stati-apertura-chiusura--variant-${variant || 'default'}`)
  const color = Color(data.stati_apertura_chiusura_id.colore)
  element.style = [`--stati-apertura-chiusura-colore: ${color.rgb().array()}`].join(';')
  elementIcon.classList.add('stati-apertura-chiusura__icon', 'material-symbols-sharp')
  elementName.classList.add('stati-apertura-chiusura__name')
  elementName.textContent = data.stati_apertura_chiusura_id.translations[0].nome

  if (data.translations[0].stati_apertura_chiusura_description) {
    elementDescription.classList.add('stati-apertura-chiusura__description')
    elementBody.title = data.translations[0].stati_apertura_chiusura_description
    elementDescription.textContent = data.translations[0].stati_apertura_chiusura_description
    elementBody.append(elementDescription)
  }

  return element
}

async function getMinisitesData(minisitesCnts) {
  try {
    const directus = new Directus('https://cms.asiago.it/')

    return (
      await directus.items('Hotel').readByQuery({
        fields: [
          'Id',
          'translations.stati_apertura_chiusura_description',
          'stati_apertura_chiusura_id.macrostato',
          'stati_apertura_chiusura_id.translations.nome',
          'stati_apertura_chiusura_id.colore',
        ],
        filter: {
          _and: [
            {Id: {_in: minisitesCnts.map(item => item.dataset.minisiteId)}},
            {stati_apertura_chiusura_id: {_nnull: true}},
          ],
        },
        deep: {
          translations: {_filter: {lingua: {id: {_eq: WC.idLingua || 1}}}},
          stati_apertura_chiusura_id: {
            translations: {_filter: {Lingua_id: {id: {_eq: WC.idLingua || 1}}}},
          },
        },
        limit: -1,
      })
    ).data
  } catch (error) {
    console.error(error)
  }
}

;(async () => {
  // if (WC.isWebcloud) {
  // 	return
  // }

  const minisitesCnts = Array.from(document.querySelectorAll('[data-stati-apertura-chiusura-cnt]'))

  if (!minisitesCnts.length) {
    return
  }

  const minisitesData = await getMinisitesData(minisitesCnts)

  if (!minisitesData) {
    return
  }

  for (const minisite of minisitesCnts) {
    const data = minisitesData.find(item => item.Id == minisite.dataset.minisiteId)

    if (!data) {
      continue
    }

    if (!WC.isWebcloud && data.stati_apertura_chiusura_id.translations[0].nome.startsWith('Bh')) {
      continue
    }

    if (!data.stati_apertura_chiusura_id.translations[0].nome.startsWith('Bh')) {
      // box itinerari (tag full)
      minisite
        .querySelector('.minisite-article-links__item--title')
        ?.after(createStatiAperturaChiusuraElement(data, 'full'))

      // miniature minisiti
      const hasTags = minisite.querySelector(
        '.minisites-view--full .minisites-view-item__tags .minisites-view-item-tags__list'
      )
      if (hasTags) {
        // con tags, finisce come primo elemento dei tags
        const liElement = document.createElement('li')
        liElement.appendChild(createStatiAperturaChiusuraElement(data))
        hasTags.insertBefore(liElement, hasTags.firstChild)
      } else {
        // miniature minisiti
        // NOTE rimosso dalle miniature hotel (.TitoloCamera)
        minisite
          .querySelector('.TitoloSci, .minisites-view--full .minisites-view-item__description')
          ?.after(createStatiAperturaChiusuraElement(data))
      }

      // home minisito (tag full)
      if (data.translations[0].stati_apertura_chiusura_description) {
        minisite?.parentElement
          ?.querySelector('.minisite-description--short')
          ?.before(createStatiAperturaChiusuraElement(data, 'full'))
      }
    }

    // testata minisito (tag standard)
    minisite
      .querySelector('.misi-flex-header__main > h2')
      ?.after(createStatiAperturaChiusuraElement(data))
  }
})()
